// ModalBox.js
import React from "react";
import { NrqlQuery,useQuery, TableChart } from "nr1";

const ModalBox = ({ isOpen, onClose, card, accountId }) => {


// Helper: count total rows across all series returned by NrqlQuery
  const getTotalRows = (nrqlData) => {
    if (!Array.isArray(nrqlData)) return 0;
    // NrqlQuery usually returns: [{ metadata: {...}, data: [...] }, ...]
    return nrqlData.reduce((acc, series) => {
      const rows = Array.isArray(series?.data) ? series.data.length : 0;
      return acc + rows;
    }, 0);
  };

// Friendly empty state component
  const EmptyState = ({ title = "No results", subtitle, details }) => (
    <div className="empty-state">
      <div className="empty-state__icon" aria-hidden>🔍</div>
      <h4 className="empty-state__title">{title}</h4>
      {subtitle && <p className="empty-state__subtitle">{subtitle}</p>}
      {details && (
        <ul className="empty-state__list">
          {details.map((d, i) => (
            <li key={i}>{d}</li>
          ))}
        </ul>
      )}
    </div>
  );


  if (!isOpen || !card) return null;

  console.log(card.modalQuery);
    if(accountId == "cross-account" || accountId == 3403951){
       accountId = 3592556;
    }
    console.log(card, accountId)
  return (
   <div className="modal-overlay">
      <div className="modal-content">
        <h3 style={{ marginTop: 0 }}>{card?.label || "All Stores Alerts"} Alerts: Store {card?.storeId}</h3>
        <button onClick={onClose} className="modal-close-button">
          &#x2715;
        </button>

        <NrqlQuery
          accountId={accountId}
          query={card.modalQuery}
          pollInterval={60000}
        >
          {({ data, loading, error }) => {
            if (loading) return <p>Loading...</p>;
            //console.log('ModalBox --> L23',data.length);
            if (error) return <p>Error: {error.message}</p>;
            
const totalRows = data?.length;
            // Log safely for debugging
            try {
              // eslint-disable-next-line no-console
              //console.log("ModalBox: rows =", totalRows, "series =", Array.isArray(data) ? data.length : 0);
            } catch {}

            if (totalRows === 0) {
              return (
                <EmptyState
                  title="No results found"
                  subtitle="There are no matching events for this view."
                  details={[
                    ''
                  ]}
                />
              );
            }

            return (
              <TableChart
                data={data}
                className="table-chart"
             />
            );
          }}
        </NrqlQuery>
      </div>
    </div>
  );
};

export default ModalBox;
